import { tagsStatsSelectors, tagsStatsThunks } from '@ucheba/store/tags/stats'
import { getSingleQuery, parseUrl } from '@ucheba/utils/helpers/router'
import { egeStatsThunks } from '@ucheba/store/ege/stats'
import { ESpecialitiesDataKeys } from '@ucheba/store/specialities/search/types'
import { ETagsStatsDataKeys } from '@ucheba/store/tags/stats/types'
import { isSubdomainMatches } from '@ucheba/utils/middlewares/defineLocationMiddleware'
import { EProgramTypes } from '@ucheba/utils/types/program'
import { NextPageContext } from 'next/dist/shared/lib/utils'
import { NextRouter } from 'next/router'
import { Store } from 'redux'
import { specialitiesSearchThunks } from '@ucheba/store/specialities/search'
import SpecialitiesPage from './index'
import {
  getDescriptionWithSection,
  getDescriptionWithTag,
  getIsInstitutionSection,
  getTitleWithSection,
  getTitleWithTag,
} from './index/bll'
import { headerActions } from '../../../components/Header/store'

SpecialitiesPage.getInitialProps = async (
  ctx: NextPageContext & { store: Store }
): Promise<any> => {
  const { store, pathname } = ctx
  const { dispatch, getState } = store
  const query = parseUrl(ctx.asPath || '').query as NextRouter['query']

  const isDomainWWW = isSubdomainMatches(ctx.req, store, 'www')

  const canonical = isDomainWWW
    ? undefined
    : 'https://www.ucheba.ru/for-abiturients/speciality'

  const isInstitutionsSection = getIsInstitutionSection(query, pathname)
  const parentId = getSingleQuery(query[ETagsStatsDataKeys.parentId])
  const tagIdsQuery = parentId ? { [ESpecialitiesDataKeys.tagIds]: parentId } : {}
  const programTypesQuery = {
    [ESpecialitiesDataKeys.programTypes]: [
      Number(query[ESpecialitiesDataKeys.topProgramTypes]) || EProgramTypes.higher,
    ],
  }

  const parents = tagsStatsSelectors.parents.selectAll(getState())

  const promise = [] as any

  if (!parents || !parents.length) {
    promise.push(
      dispatch<any>(
        tagsStatsThunks.fetchParents({
          ctx,
          data: programTypesQuery,
        })
      )
    )
  }

  await dispatch<any>(
    specialitiesSearchThunks.fetch({
      ctx,
      data: {
        ...query,
        limit: 10,
        [ESpecialitiesDataKeys.topProgramTypes]: [
          Number(query[ESpecialitiesDataKeys.topProgramTypes]) || EProgramTypes.higher,
        ],
      },
    })
  )

  await Promise.all([
    ...promise,

    parentId &&
      dispatch<any>(
        tagsStatsThunks.fetchChildren({
          ctx,
          data: {
            ...programTypesQuery,
            parentId,
          },
        })
      ),

    isInstitutionsSection &&
      dispatch<any>(
        egeStatsThunks.fetch({
          ctx,
          data: {
            limit: 10,
            ...programTypesQuery,
            ...tagIdsQuery,
            limit: 20,
          },
        })
      ),
  ])

  const tags = tagsStatsSelectors.parents.selectEntities(store.getState())

  dispatch(headerActions.toggleHeader(true))

  return {
    canonical,
    content: {
      seo: {
        meta: {
          title:
            getTitleWithTag({
              tags,
              currentTag: parentId,
              isInstitutionsSection,
            }) || getTitleWithSection({ isInstitutionsSection }),
          description:
            getDescriptionWithTag({
              tags,
              currentTag: parentId,
              isInstitutionsSection,
            }) || getDescriptionWithSection({ isInstitutionsSection }),
        },
      },
    },
  }
}

export default SpecialitiesPage
